module.exports = __webpack_public_path__ + "static/assets/93fb7d9d5ebefbe760b3b6f8d35356a4.svg";